import { render, staticRenderFns } from "./WEntradas.vue?vue&type=template&id=3ba2bd1d&scoped=true&"
import script from "./WEntradas.vue?vue&type=script&lang=js&"
export * from "./WEntradas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba2bd1d",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WEventPrice from '@/components/WEventPrice.vue'
import WInput from '@/components/WInput.vue'
import WTextarea from '@/components/WTextarea.vue'
autoInstallComponents(component, {WEventPrice,WInput,WTextarea})
